"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactScriptTag = _interopRequireDefault(require("react-script-tag"));
var _reactRouterDom = require("react-router-dom");
var _booking = require("./helpers/booking");
var _LoadingView = _interopRequireDefault(require("./LoadingView"));
var _TermsCheckbox = _interopRequireDefault(require("./TermsCheckbox"));
var _newComponents = require("./new-components");
var _WalletPayment = _interopRequireDefault(require("./booking-funnel/WalletPayment/WalletPayment"));
var _querystring = require("./helpers/querystring");
var _pricing = require("./helpers/pricing");
var _constants = require("./constants");
var _CardFeeModal = _interopRequireDefault(require("./new-components/CardFeeModal/CardFeeModal"));
var _UpdatePaymentCard = _interopRequireDefault(require("./new-components/UpdatePaymentCard/UpdatePaymentCard"));
var _envConstants = require("./env-constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CheckoutBridge = /*#__PURE__*/function (_PureComponent) {
  function CheckoutBridge(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CheckoutBridge);
    _this = _callSuper(this, CheckoutBridge, [props]);
    _this.state = {
      formLoaded: false,
      error: undefined,
      paying: false,
      cardHolder: '',
      street: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      cardValid: false,
      cardType: '',
      cardScheme: '',
      payToken: '',
      last4: '',
      expiryMonth: '',
      expiryYear: '',
      cardLogoName: '',
      cardSelected: false,
      cardCharge: '',
      cardCountry: '',
      needsToCheckPayment: 'cko-session-id' in (0, _querystring.getQuery)(window.location)
    };
    _this.handleScriptError = _this.handleScriptError.bind(_this);
    _this.handleScriptLoad = _this.handleScriptLoad.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.useAnotherCard = _this.useAnotherCard.bind(_this);
    _this.handlePaymentValues = _this.handlePaymentValues.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CheckoutBridge, _PureComponent);
  return (0, _createClass2["default"])(CheckoutBridge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.Frames) {
        this.handleScriptLoad();
      }
      if (this.state.needsToCheckPayment) {
        var query = (0, _querystring.getQuery)(window.location);
        this.checkPayment(query['cko-session-id'], query.service);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.state.needsToCheckPayment && window.Frames && !this.formHasLoaded()) {
        this.embedForm();
      }
      // currency changed or card changes
      if (!!this.state.cardScheme && (prevProps.currency !== this.props.currency || prevState.cardScheme !== this.state.cardScheme)) {
        // check amex currency stuff
        this.amexCurrencyCheck();
      }
    }
  }, {
    key: "amexCurrencyCheck",
    value: function amexCurrencyCheck() {
      var cardScheme = this.state.cardScheme;
      var currency = this.props.currency;
      if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.AMEX.toLowerCase() && ['AUD', 'CAD'].includes(currency)) {
        var error = {
          message: "You cannot pay in ".concat(currency, " with ").concat(_constants.CREDIT_CARD_SCHEMES.AMEX, " card, try different currency or another card")
        };
        this.setState({
          error: error
        });
      } else {
        this.setState({
          error: undefined
        });
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      var _this2 = this;
      e.preventDefault();
      this.props.onSubmit();
      var _this$state = this.state,
        cardHolder = _this$state.cardHolder,
        zip = _this$state.zip,
        country = _this$state.country,
        street = _this$state.street,
        city = _this$state.city,
        state = _this$state.state;
      this.setState({
        paying: true,
        error: undefined
      });

      // enables to re-submit the form if it's been submitted before:
      // window.Frames.enableSubmitForm(); // commenting out to see if this is culprit of occasional double payments

      window.Frames.cardholder = {
        name: cardHolder,
        billingAddress: {
          addressLine1: street || null,
          zip: zip,
          country: country.toUpperCase(),
          city: city || null,
          state: state || null
        }
      };
      window.Frames.submitCard().then(function (data) {
        _this2.setState({
          paying: false,
          cardType: data.card_type,
          cardScheme: data.scheme,
          payToken: data.token,
          last4: data.last4,
          expiryMonth: data.expiry_month,
          expiryYear: data.expiry_year,
          formLoaded: false,
          cardSelected: true,
          cardCountry: data.issuer_country,
          cardCharge: _this2.props.skipCardCharges ? 0 : (0, _pricing.checkCardCharges)(data.card_type, data.scheme, data.issuer_country)
        });
      })["catch"](function (error) {
        _this2.props.onError(error);
        _this2.setState({
          error: error,
          paying: false
        });
        console.error('Tokenization failed: ', error);
      });
    }
  }, {
    key: "checkPayment",
    value: function checkPayment(token, service) {
      var _this3 = this;
      this.props.checkPaymentInfo(this.props.orderId, token, service, this.props.scheduledPayments, this.props.isScheduledPaymentsUpdate).then(function (response) {
        if (window && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + window.location.search.replace(/[\?&]cko-session-id=[^&]+/, '').replace(/^&/, '?') + window.location.hash);
        }
        if (response.status === 'success' && response.data) {
          _this3.props.onPaymentSuccess(response.data);
        }
        if (response.status === 'failed') {
          var error = response.error || {
            message: response.message
          };
          _this3.setState({
            error: error,
            needsToCheckPayment: false
          });
          _this3.props.onError(error);
        }
      });
    }
  }, {
    key: "useAnotherCard",
    value: function useAnotherCard() {
      this.setState({
        paying: false,
        cardHolder: '',
        cardType: '',
        cardScheme: '',
        payToken: '',
        last4: '',
        expiryMonth: '',
        expiryYear: '',
        cardCountry: '',
        street: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        formLoaded: false,
        cardSelected: false
      });
      this.embedForm();
    }
  }, {
    key: "submitPayment",
    value: function submitPayment(payToken, cardHolder, cardScheme, cardType, billingCountry) {
      this.props.onSuccess(payToken, cardHolder, cardScheme, cardType, billingCountry);
    }
  }, {
    key: "embedForm",
    value: function embedForm() {
      var _this4 = this;
      // initalize Frames sdk
      window.Frames.init({
        publicKey: this.props.apiKey,
        localization: {
          expiryMonthPlaceholder: 'MM',
          expiryYearPlaceholder: 'YY',
          cardNumberPlaceholder: '**** **** **** ****',
          cvvPlaceholder: '123'
        },
        style: {
          base: {
            paddingTop: '5px',
            fontFamily: 'sans-serif',
            letterSpacing: '0.7px',
            color: 'rgb(51, 51, 51)'
          },
          invalid: {
            color: 'rgb(255, 71, 71)'
          },
          placeholder: {
            base: {
              fontFamily: 'sans-serif',
              letterSpacing: '0.7px',
              color: '#79797c'
            }
          }
        }
      });
      window.Frames.addEventHandler(window.Frames.Events.CARD_VALIDATION_CHANGED, function () {
        _this4.setState({
          cardValid: window.Frames.isCardValid(),
          formLoaded: _this4.formHasLoaded()
        });
      });
    }
  }, {
    key: "handleScriptError",
    value: function handleScriptError(error) {
      console.error(error);
    }
  }, {
    key: "handlePaymentValues",
    value: function handlePaymentValues(card_type, scheme, token, last4, expiry_month, expiry_year, issuer_country) {
      this.setState({
        paying: false,
        cardType: card_type,
        cardScheme: scheme,
        payToken: token,
        last4: last4,
        expiryMonth: expiry_month,
        expiryYear: expiry_year,
        cardCountry: issuer_country,
        formLoaded: false,
        cardSelected: true,
        cardCharge: this.props.skipCardCharges ? 0 : (0, _pricing.checkCardCharges)(card_type, scheme, issuer_country)
      });
    }
  }, {
    key: "formHasLoaded",
    value: function formHasLoaded() {
      if (!this._embed) {
        return false;
      }
      return this._embed && this._embed.innerHTML && this._embed.innerHTML.length > 0;
    }
  }, {
    key: "handleScriptLoad",
    value: function handleScriptLoad() {
      this.forceUpdate();
    }
  }, {
    key: "renderLoadingView",
    value: function renderLoadingView() {
      return /*#__PURE__*/_react["default"].createElement(_LoadingView["default"], {
        title: "Loading"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$state2 = this.state,
        error = _this$state2.error,
        formLoaded = _this$state2.formLoaded,
        paying = _this$state2.paying,
        cardValid = _this$state2.cardValid,
        cardHolder = _this$state2.cardHolder,
        street = _this$state2.street,
        city = _this$state2.city,
        state = _this$state2.state,
        zip = _this$state2.zip,
        country = _this$state2.country,
        cardType = _this$state2.cardType,
        last4 = _this$state2.last4,
        cardScheme = _this$state2.cardScheme,
        expiryMonth = _this$state2.expiryMonth,
        expiryYear = _this$state2.expiryYear,
        cardLogoName = _this$state2.cardLogoName,
        payToken = _this$state2.payToken,
        cardSelected = _this$state2.cardSelected,
        cardCharge = _this$state2.cardCharge,
        cardCountry = _this$state2.cardCountry;
      var _this$props = this.props,
        processing = _this$props.processing,
        girls = _this$props.girls,
        guys = _this$props.guys,
        product = _this$props.product,
        baseUrl = _this$props.baseUrl,
        minAge = _this$props.minAge,
        canCancelBooking = _this$props.canCancelBooking,
        visa = _this$props.visa,
        mastercard = _this$props.mastercard,
        amex = _this$props.amex,
        disableWalletPayments = _this$props.disableWalletPayments,
        companyId = _this$props.companyId,
        weekTerms = _this$props.weekTerms,
        destinationId = _this$props.destinationId,
        travelInsuranceCheckBox = _this$props.travelInsuranceCheckBox,
        scheduledPayments = _this$props.scheduledPayments,
        isBookingUkBased = _this$props.isBookingUkBased,
        hasPromoCodeApplied = _this$props.hasPromoCodeApplied,
        isScheduledPaymentsUpdate = _this$props.isScheduledPaymentsUpdate;
      var isPaying = paying || processing;
      var countryOptions = _booking.countriesSorted.map(function (countryData) {
        return {
          value: countryData.code,
          text: countryData.name.length > 24 ? "".concat(countryData.name.slice(0, 24), "...") : countryData.name
        };
      });
      var continueButtonEnabled = !isPaying && cardValid && cardHolder && zip && country;
      if (cardScheme !== undefined) {
        if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.VISA.toLowerCase()) {
          this.setState({
            cardLogoName: 'visa'
          });
        } else if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.MASTERCARD.toLowerCase()) {
          this.setState({
            cardLogoName: 'mastercard'
          });
        } else if (cardScheme.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.AMEX.toLowerCase()) {
          this.setState({
            cardLogoName: 'amex'
          });
        } else {
          this.setState({
            cardLogoName: ''
          });
        }
      }
      var totalToPay = '';
      var cardChargeAmount = this.props.paidAmount / 100 * cardCharge;
      if (cardCharge) {
        totalToPay = (this.props.paidAmount + cardChargeAmount) / 100;
      } else {
        totalToPay = this.props.paidAmount / 100;
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactScriptTag["default"], {
        src: "https://cdn.checkout.com/js/framesv2.min.js",
        onError: this.handleScriptError,
        onLoad: this.handleScriptLoad
      }), !disableWalletPayments && !cardSelected && /*#__PURE__*/_react["default"].createElement(_WalletPayment["default"], (0, _extends2["default"])({}, this.props, {
        handlePaymentValues: this.handlePaymentValues
      })), error && /*#__PURE__*/_react["default"].createElement(_newComponents.Alert, {
        className: "margin-y-md",
        type: "warning",
        text: "".concat(error.message),
        show: error,
        onClose: function onClose() {
          return _this5.setState({
            error: null
          });
        }
      }), cardSelected && isScheduledPaymentsUpdate && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
        className: "full-width margin-top-md border-top border-contrast-low d8-u-radius-md "
      }), /*#__PURE__*/_react["default"].createElement(_UpdatePaymentCard["default"], {
        cardLogoName: cardLogoName,
        last4: last4,
        expiryMonth: expiryMonth,
        expiryYear: expiryYear,
        useAnotherCard: this.useAnotherCard
      })), cardSelected && !isScheduledPaymentsUpdate && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
        className: "full-width margin-top-md border-top border-contrast-low d8-u-radius-md "
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "d8-u-component-padding d8-u-radius-md border width-100% margin-top-lg margin-bottom-lg"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "margin-top-0 margin-bottom-0 flex items-center justify-between"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-center"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: cardLogoName && cardLogoName,
        className: "margin-right-sm"
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "margin-right-sm"
      }, "**** ", last4)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-center"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "d8-u-color-contrast-medium d8-u-text-semi-bold text-sm margin-right-md"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "hidden inline-block@sm"
      }, "Expiry "), " ", expiryMonth, " / ", expiryYear.toString().slice(-2)), /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
        className: "d8-u-color-error d8-u-text-semi-bold",
        style: {
          fontWeight: '400'
        },
        text: "Remove",
        buttonType: _newComponents.BUTTON_TYPES.NO_STYLE,
        buttonSize: _newComponents.BUTTON_SIZES.SMALL,
        onClick: this.useAnotherCard
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-component"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "d8-u-font-size-base"
      }, "Payment summary:")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex justify-between d8-u-color-contrast-medium margin-y-sm"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-sm"
      }, _envConstants.ENV.SITE === 'qd' ? 'Course' : 'Booking'), /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-sm"
      }, (0, _pricing.formatCurrency)(this.props.paidAmount / 100, this.props.currency, this.props.currency, false))), !!cardChargeAmount && /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex justify-between d8-u-color-contrast-medium margin-bottom-sm"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-sm"
      }, "Fee ", /*#__PURE__*/_react["default"].createElement(_CardFeeModal["default"], {
        amount: this.props.paidAmount
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-sm"
      }, (0, _pricing.formatCurrency)(cardChargeAmount / 100, this.props.currency, this.props.currency, false))), !!hasPromoCodeApplied && /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex justify-between d8-u-color-contrast-medium margin-bottom-sm"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-sm"
      }, "Promo code"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-sm"
      }, "Applied")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex justify-between d8-u-text-bold margin-top-md"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, "Total:")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex items-center"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.CurrencyDropdown, {
        buttonSize: _newComponents.BUTTON_SIZES.SMALL,
        buttonType: _newComponents.BUTTON_TYPES.GHOST_BG
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "margin-left-sm"
      }, (0, _pricing.formatCurrency)(totalToPay, this.props.currency, this.props.currency, false)))))), cardSelected && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
        className: "full-width margin-y-md border-top border-contrast-low d8-u-radius-md "
      }), /*#__PURE__*/_react["default"].createElement(_newComponents.Toggle, null, function (_ref) {
        var cardChargeAgreed = _ref.on,
          toggleCardChargeAgreed = _ref.toggle;
        return /*#__PURE__*/_react["default"].createElement(_newComponents.Toggle, null, function (_ref2) {
          var termsAgreed = _ref2.on,
            toggleTermsAgreed = _ref2.toggle;
          return /*#__PURE__*/_react["default"].createElement(_newComponents.Toggle, null, function (_ref3) {
            var travelTermsAgreed = _ref3.on,
              toggleTravelTermsAgreed = _ref3.toggle;
            var payButtonEnabled = !isPaying && termsAgreed && !error && (travelInsuranceCheckBox ? travelTermsAgreed : true) && (cardChargeAmount > 0 ? cardChargeAgreed : true);
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TermsCheckbox["default"], {
              id: "card-method-terms",
              travelTermsCheckboxId: "card-method-travel-terms",
              cardChargeCheckboxId: "card-charge-check",
              product: product,
              termsAgreed: termsAgreed,
              toggleTermsAgreed: toggleTermsAgreed,
              girls: girls,
              guys: guys,
              baseUrl: baseUrl,
              minAge: minAge,
              companyId: companyId,
              weekTerms: weekTerms,
              destinationId: destinationId,
              scheduledPayments: scheduledPayments,
              isScheduledPaymentsUpdate: isScheduledPaymentsUpdate,
              travelInsuranceCheckBox: travelInsuranceCheckBox,
              travelTermsAgreed: travelTermsAgreed,
              toggleTravelTermsAgreed: toggleTravelTermsAgreed,
              isBookingUkBased: isBookingUkBased,
              cardChargeAmount: cardChargeAmount,
              cardCharge: cardCharge,
              cardChargeAgreed: cardChargeAgreed,
              toggleCardChargeAgreed: toggleCardChargeAgreed,
              currency: _this5.props.currency,
              cardType: cardType,
              cardScheme: cardScheme
            }), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
              className: "margin-top-lg"
            }, !isScheduledPaymentsUpdate ? /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
              className: !isPaying && "d8-u-text-bold",
              onClick: function onClick() {
                return _this5.submitPayment(payToken, cardHolder, cardScheme, cardType, cardCountry);
              },
              text: isPaying ? 'Paying...' : "Pay Now (".concat((0, _pricing.formatCurrency)(totalToPay, _this5.props.currency, _this5.props.currency, false), ")"),
              buttonType: _newComponents.BUTTON_TYPES.SUCCESS,
              disabled: !payButtonEnabled,
              fullWidth: true
            }) : /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
              className: !isPaying && "d8-u-text-bold",
              onClick: function onClick() {
                return _this5.submitPayment(payToken, cardHolder, cardScheme, cardType, cardCountry);
              },
              text: isPaying ? 'Updating...' : "Update",
              buttonType: _newComponents.BUTTON_TYPES.SUCCESS,
              disabled: !payButtonEnabled,
              fullWidth: true
            }), canCancelBooking && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
              className: "margin-top-sm block",
              to: "/booking/cancel"
            }, /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
              buttonType: _newComponents.BUTTON_TYPES.GHOST,
              fullWidth: true,
              text: "Cancel booking"
            })))));
          });
        });
      })), /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: this.onSubmit,
        id: "payment-form",
        className: "checkout-form",
        style: {
          display: formLoaded ? 'block' : 'none'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "d8-c-input margin-bottom-sm"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-md",
        htmlFor: "cardNumber",
        "data-section": "form-label"
      }, "Credit Card Number"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "relative"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(div) {
          _this5._embed = div;
        },
        id: "cardNumber",
        className: "card-number-frame form-control padding-y-xs",
        style: {
          height: 46
        }
      }), /*#__PURE__*/_react["default"].createElement(_newComponents.Media, {
        greaterThanOrEqual: _newComponents.BREAKPOINTS.MD
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex items-center absolute payment-methods-wrapper"
      }, visa && /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: "visa",
        className: "margin-right-xs"
      }), mastercard && /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: "mastercard",
        className: "margin-right-xs"
      }), amex && /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: "amex",
        className: "margin-right-xs"
      })))), /*#__PURE__*/_react["default"].createElement(_newComponents.Media, {
        lessThan: _newComponents.BREAKPOINTS.MD
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex items-center margin-top-sm"
      }, visa && /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: "visa",
        className: "margin-right-xs"
      }), mastercard && /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: "mastercard",
        className: "margin-right-xs"
      }), amex && /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: "amex",
        className: "margin-right-xs"
      })))), /*#__PURE__*/_react["default"].createElement(_newComponents.Input, {
        label: "Cardholder's name *",
        placeholder: "Cardholder's name",
        id: "cardHolder",
        value: cardHolder,
        onChange: function onChange(e) {
          return _this5.setState({
            cardHolder: e.target.value
          });
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid grid-gap-md"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6 d8-c-input"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-md",
        htmlFor: "expiryDate",
        "data-section": "form-label"
      }, "Valid Until"), /*#__PURE__*/_react["default"].createElement("div", {
        id: "expiryDate",
        className: "expiry-date-frame form-control padding-y-xs",
        style: {
          height: 46
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6 d8-c-input"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label margin-bottom-md",
        htmlFor: "cvv",
        "data-section": "form-label"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Tooltip, {
        title: 'The ("Card Verification Value") on your credit card or debit card ' + 'is a 3-4 digit number located on the back/front of your card'
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "margin-right-xs"
      }, "CVV"), /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: "info-i-fill",
        fill: _newComponents.COLORS.BLACK
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        id: "cvv",
        className: "cvv-frame form-control padding-y-xs",
        style: {
          height: 46
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "margin-top-lg margin-bottom-md"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "text-md"
      }, "Billing Address")), /*#__PURE__*/_react["default"].createElement(_newComponents.Input, {
        label: "Street Address",
        placeholder: "Street name and number",
        id: "street",
        value: street,
        onChange: function onChange(e) {
          return _this5.setState({
            street: e.target.value
          });
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid grid-gap-md"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Input, {
        label: "City",
        placeholder: "City",
        id: "city",
        value: city,
        onChange: function onChange(e) {
          return _this5.setState({
            city: e.target.value
          });
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Input, {
        label: "State",
        placeholder: "State / Province / Region",
        id: "state",
        value: state,
        onChange: function onChange(e) {
          return _this5.setState({
            state: e.target.value
          });
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid grid-gap-md"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Input, {
        label: "Zip Code *",
        placeholder: "Zip / Postal Code",
        required: true,
        id: "zip",
        value: zip,
        onChange: function onChange(e) {
          return _this5.setState({
            zip: e.target.value
          });
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Select, {
        label: "Country *",
        placeholder: "Please Choose...",
        required: true,
        id: "country",
        value: country,
        options: countryOptions,
        onChange: function onChange(e) {
          return _this5.setState({
            country: e.target.value
          });
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "margin-top-lg"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
        type: "submit",
        form: "payment-form",
        text: isPaying ? 'Confirming...' : 'Continue',
        buttonType: _newComponents.BUTTON_TYPES.SUCCESS,
        disabled: !continueButtonEnabled,
        fullWidth: true
      }), canCancelBooking && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        className: "margin-top-sm block",
        to: "/booking/cancel"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
        buttonType: _newComponents.BUTTON_TYPES.GHOST,
        fullWidth: true,
        text: "Cancel booking"
      })))), !formLoaded && !cardSelected && this.renderLoadingView());
    }
  }]);
}(_react.PureComponent);
CheckoutBridge.propTypes = {
  onSuccess: _propTypes["default"].func.isRequired,
  onPaymentSuccess: _propTypes["default"].func.isRequired,
  onError: _propTypes["default"].func.isRequired,
  processing: _propTypes["default"].bool.isRequired,
  apiKey: _propTypes["default"].string.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  checkPaymentInfo: _propTypes["default"].func.isRequired,
  orderId: _propTypes["default"].number.isRequired,
  girls: _propTypes["default"].string,
  guys: _propTypes["default"].string,
  product: _propTypes["default"].string,
  baseUrl: _propTypes["default"].string,
  minAge: _propTypes["default"].number,
  canCancelBooking: _propTypes["default"].bool,
  visa: _propTypes["default"].bool,
  mastercard: _propTypes["default"].bool,
  amex: _propTypes["default"].bool,
  disableWalletPayments: _propTypes["default"].bool,
  companyId: _propTypes["default"].number,
  destinationId: _propTypes["default"].number,
  weekTerms: _propTypes["default"].string,
  travelInsuranceCheckBox: _propTypes["default"].bool,
  isBookingUkBased: _propTypes["default"].bool,
  scheduledPayments: _propTypes["default"].array,
  paidAmount: _propTypes["default"].number,
  currency: _propTypes["default"].string,
  skipCardCharges: _propTypes["default"].bool,
  hasPromoCodeApplied: _propTypes["default"].bool,
  isScheduledPaymentsUpdate: _propTypes["default"].bool
};
var _default = exports["default"] = CheckoutBridge;